import React from 'react';
import { connect } from 'react-redux';
import { bool, object } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { Icon } from '@fiverr-private/fit';
import { r_circle } from '@fiverr-private/icons';

import './style.scss';

const ONLINE_INDICATION_SIZE = 4;

export const Online = () => (
    <div className={classNames('status', 'online-indicator')}>
        <Icon className="circle-icon" size={ONLINE_INDICATION_SIZE}>{r_circle}</Icon>
        <I18n k={'general.online'}/>
    </div>
);

export const Vacation = () => (
    <div className={classNames('status', 'ooo-indicator')}>
        <I18n k={'gig_page_perseus.seller_card.unavailable'}/>
    </div>
);

const Status = ({ isOnline = false }, { general }) => {
    const { isOnVacation } = general;

    if (isOnVacation) {
        return <Vacation/>;
    } else if (isOnline) {
        return <Online/>;
    } else {
        return null;
    }
};

Status.propTypes = {
    isOnline: bool
};

Status.contextTypes = {
    general: object
};

const mapStateToProps = ({ seller: { isOnline } = {} }) => ({
    isOnline
});

export { Status };
export default connect(mapStateToProps)(Status);
